export default "__VITE_ASSET__CHkp3_3U__"